exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content{margin:3%}.content .welcome{font-size:1.25em}.content .video-wrapper{position:relative;padding-bottom:53.5%;padding-top:25px;height:0}.content .video-wrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%}.content .place-title{font-size:1.4em}.content .card-content img{width:100%}.content .map .card-content{padding:0}.content .map iframe{display:block;border:0;width:100%;height:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/Content.css
// module id = 383
// module chunks = 0